/**
 * String helpers
 *
 * @package lib-shared
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

/**
 * Returns if two array of strings are equal
 *
 * @param a Left array
 * @param b Right array
 */
export function areArrayOfStringsEqual(a: string[], b: string[]): boolean {
	if (!Array.isArray(a) || !Array.isArray(b)) {
		return false;
	}

	if (a.length !== b.length) {
		return false;
	}

	for (let i = 0; i < a.length; i++) {
		if (a[i] !== b[i]) {
			return false;
		}
	}

	return true;
}
